import { Injector, Type } from '@angular/core';

export let AppInjector: Injector;

export function setAppInjector(injector: Injector) {
  AppInjector = injector;
}

/**
 * Property decorator that lazily resolves an Angular service from AppInjector.
 * Provides a clean syntax similar to inject() in Angular 15+.
 */
export function AutoInject<T>(token: Type<T> | any): PropertyDecorator {
  return function (target: any, propertyKey: string | symbol) {
    const hiddenKey = `__auto_injected_${String(propertyKey)}`;

    Object.defineProperty(target, propertyKey, {
      get(this: any): T {
        if (this[hiddenKey] === undefined) {
          this[hiddenKey] = AppInjector ? AppInjector.get(token, null) : null;
        }
        return this[hiddenKey];
      },
      set(this: any, value: T) {
        this[hiddenKey] = value;
      },
      enumerable: true,
      configurable: true,
    });
  };
}
